import { SectionNotFound } from '.';

export default SectionNotFound;
